import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class PaymentModalStore extends BaseModalStore {
  @observable payUrl = '';
  closeCallback = noop;

  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  setPayUrl(payUrl) {
    this.payUrl = payUrl || '';
  }

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.onClose();
    this.closeCallback();
    this.clearStyle();
  };
}

export default PaymentModalStore;
